import Axios from 'axios';
import { env } from 'core/constants/env.constants';
import {
  requestFailedInterceptor,
  requestInterceptor,
  responseFailedInterceptor,
  responseInterceptor,
} from './axios.interceptors';

// Create instance.
const axios = Axios.create({
  // baseURL: apiRoutes.base,
  timeout: env.VITE_API_TIMEOUT,
});
// Setup interceptors.
if (axios) {
  axios.interceptors.request.use(requestInterceptor, requestFailedInterceptor);
  axios.interceptors.response.use(responseInterceptor, responseFailedInterceptor);
}

const setHeader = header => {
  axios.defaults.headers.common = { ...header };
};

const addHeader = (key, header) => {
  axios.defaults.headers.common[key] = header;
};

export { addHeader, axios, setHeader };
